/**
 * O tema Mantine alimentado pelos tokens.
 *
 * Mantine é o motor; a identidade vem de `tokens.css`/`tokens.ts`. Nenhum
 * componente deve ler cor "solta" daqui — lê `var(--eva-*)` ou usa
 * `color="brand"`, que resolve para a escala da marca corrente.
 */
import { createTheme, type MantineThemeOverride } from '@mantine/core';
import { PRIMARY_SHADE, type BrandTokens, tokensFromBrand } from './tokens';

export function createEvaTheme(tokens: BrandTokens = tokensFromBrand()): MantineThemeOverride {
  return createTheme({
    primaryColor: 'brand',
    primaryShade: PRIMARY_SHADE as 8,
    colors: { brand: tokens.shades },
    white: '#FFFFFF',
    black: tokens.text,
    fontFamily: 'var(--eva-font)',
    fontFamilyMonospace: 'var(--eva-font-mono)',
    headings: { fontFamily: 'var(--eva-font)', fontWeight: '700' },
    defaultRadius: 'md',
    radius: { sm: '8px', md: '12px', lg: '16px', xl: '24px' },
    cursorType: 'pointer',
    // sm (48em = 768px) é a fronteira telefone/tablet — PHONE_MAX_PX + 1.
    breakpoints: { xs: '30em', sm: '48em', md: '62em', lg: '75em', xl: '88em' },
    components: {
      Button: { defaultProps: { radius: 'md' }, styles: { root: { fontWeight: 600 } } },
      Card: { styles: { root: { borderRadius: 'var(--eva-radius-md)', border: '1px solid var(--eva-border)' } } },
      Paper: { styles: { root: { borderRadius: 'var(--eva-radius-md)' } } },
      Modal: { styles: { content: { borderRadius: 'var(--eva-radius-lg)' } } },
      TextInput: { styles: { input: { borderRadius: 'var(--eva-radius-sm)' } } },
      PasswordInput: { styles: { input: { borderRadius: 'var(--eva-radius-sm)' } } },
      Textarea: { styles: { input: { borderRadius: 'var(--eva-radius-sm)' } } },
      Select: { styles: { input: { borderRadius: 'var(--eva-radius-sm)' } } },
    },
  });
}
